module.exports = __webpack_public_path__ + "static/img/i105.06e596aa.png";